import script from "./WarningPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./WarningPopup.vue?vue&type=script&setup=true&lang=ts"

import "./WarningPopup.vue?vue&type=style&index=0&id=8730fe60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8730fe60"]])

export default __exports__